import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";

import styles from "./SpeakerLayout.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Preparations.messages";

type SpeakerLayoutModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const SpeakerLayoutModal: React.FC<SpeakerLayoutModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const bulletPoints = [
    formatMessage(messages.speakerLayoutModalSlide2BulletPoint1),
    formatMessage(messages.speakerLayoutModalSlide2BulletPoint2),
    formatMessage(messages.speakerLayoutModalSlide2BulletPoint3),
    formatMessage(messages.speakerLayoutModalSlide2BulletPoint4),
  ];

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        <div className={styles.content}>
          <h2 className={styles.title}>{formatMessage(messages.speakerLayoutModalTitle)}</h2>
          <p className={styles.description}>{formatMessage(messages.speakerLayoutModalDescription)}</p>
        </div>
        <div className={styles.divider}></div>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
        <SpatialCarousel showBreadcrumbs>
          {[
            <div key={1} className={styles.carouselItem}>
              <img
                className={styles.speakersSetup}
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/1.jpg`}
                alt="feature-comparison"
              />
              <div className={styles.imgDescription}>{formatMessage(messages.speakerLayoutModalSlide1Description)}</div>
            </div>,
            <div key={2} className={styles.carouselItem}>
              <ui.Scrollbars key={2}>
                <p className={styles.topText}>{formatMessage(messages.speakerLayoutModalSlide2TopText)}</p>
                <ul className={styles.bulletPoints}>
                  {bulletPoints.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
                <p className={styles.bottomText}>{formatMessage(messages.speakerLayoutModalSlide2BottomText)}</p>
              </ui.Scrollbars>
            </div>,
          ]}
        </SpatialCarousel>
      </div>
    </ui.Modal>
  );
};
